import React from 'react'

import ModalAlert from '../../../../ui/Modals/ModalAlert'

function RecoverError (props) {
  return (
    <ModalAlert
      type='error'
      active={props.active}
      title='Erro ao recuperar senha!'
      description={props.description}
      textButton='Confirmar'
      onClick={props.onClick}
    />
  )
}

export default RecoverError
